// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  campaignId: __t.string().name("campaign_id"),
  factionId: __t.string().name("faction_id"),
  kind: __t.string(),
  name: __t.string(),
  rosterJson: __t.string().name("roster_json"),
  lon: __t.f64(),
  lat: __t.f64(),
  ownerUserId: __t.string().name("owner_user_id"),
  ownerName: __t.string().name("owner_name"),
});
